import React from "react";

type UserIconProps = {
  color?: string;
};

const UserIcon: React.FC<UserIconProps> = ({ color = "#0D0D0D" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 12C13.1867 12 14.3467 11.6481 15.3334 10.9888C16.3201 10.3295 17.0892 9.39246 17.5433 8.29255C17.9974 7.19264 18.1162 5.98678 17.8847 4.82689C17.6532 3.66699 17.0818 2.59932 16.2426 1.75736C15.4035 0.915399 14.3358 0.344005 13.1759 0.112482C12.016 -0.119041 10.8102 -0.000195503 9.71025 0.453885C8.61034 0.907966 7.67332 1.67714 7.01396 2.66381C6.35461 3.65047 6.00272 4.81044 6.00272 6C6.00272 7.5913 6.63415 9.11742 7.75744 10.2426C8.88073 11.3679 10.4087 12 12 12ZM12 2C12.7911 2 13.5645 2.2346 14.2223 2.67412C14.8801 3.11365 15.3928 3.73836 15.6955 4.46927C15.9983 5.20017 16.0775 6.00444 15.9231 6.78036C15.7688 7.55628 15.3878 8.26902 14.8284 8.82843C14.269 9.38784 13.5563 9.7688 12.7804 9.92314C12.0044 10.0775 11.2002 9.99827 10.4693 9.69552C9.73836 9.39277 9.11365 8.88008 8.67412 8.22228C8.2346 7.56449 8 6.79113 8 6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2ZM20 22V21C20 19.1435 19.2625 17.363 17.9497 16.0503C16.637 14.7375 14.8565 14 13 14H11C9.14348 14 7.36301 14.7375 6.05025 16.0503C4.7375 17.363 4 19.1435 4 21V22H6V21C6 19.6739 6.52678 18.4021 7.46447 17.4645C8.40215 16.5268 9.67392 16 11 16H13C14.3261 16 15.5979 16.5268 16.5355 17.4645C17.4732 18.4021 18 19.6739 18 21V22H20Z"
      fill={color}
    />
  </svg>
);

export default UserIcon;
